;(() => {
  const SHOW_BTN_LOADING_TIMEOUT = 15000
  const loadingTimeouts = new Map()

  function resetBtnLoadingState($btn) {
    clearTimeout(loadingTimeouts.get($btn[0]))
    loadingTimeouts.delete($btn[0])
    $btn.toggleClass("btn_loading btn_disabled", false)
    $btn.removeAttr("disabled")
  }

  function showBtnLoadingState($btn) {
    $btn.toggleClass("btn_loading btn_disabled", true)
    $btn.attr("disabled", true)

    clearTimeout(loadingTimeouts.get($btn[0]))
    loadingTimeouts.set(
      $btn[0],
      setTimeout(() => resetBtnLoadingState($btn), SHOW_BTN_LOADING_TIMEOUT),
    )
  }

  window.HB = window.HB || {}
  window.HB.showBtnLoadingState = showBtnLoadingState

  window.addEventListener("pageshow", (event) => {
    if (!event.persisted) return
    loadingTimeouts.forEach((_timeout, btn) => resetBtnLoadingState($(btn)))
  })

  $(() => {
    // similar front/app/assets/javascripts/front/situational/add_transfers/index.js
    // buttons within forms
    $(document).on("submit", "form", (event) => {
      const $form = $(event.target)
      const $btn = $form
        .find("button[data-disable-with], button[data-loading]")
        .first()
      if ($btn.length) {
        showBtnLoadingState($btn)
      }
    })

    // buttons without forms
    $(document).on("click", "button[data-loading]", function clickHandler() {
      if ($(this).closest("form").length < 1) {
        showBtnLoadingState($(this))
      }
    })

    // links
    $(document).on("click", "a[data-loading]", function clickHandler() {
      showBtnLoadingState($(this))
    })
  })
})()
